import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "";

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState("loading"); // 'loading' | 'ok' | 'unauth'

  useEffect(() => {
    let mounted = true;
    async function check() {
      try {
        const res = await fetch(`${API_BASE}/api/auth/check`, {
          method: "GET",
          credentials: "include", // send cookie
        });
        if (!mounted) return;
        if (res.ok) {
          // success
          sessionStorage.setItem("isAuthenticated", "true"); // keep backward compatibility
          setStatus("ok");
        } else {
          sessionStorage.removeItem("isAuthenticated");
          setStatus("unauth");
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        sessionStorage.removeItem("isAuthenticated");
        if (mounted) setStatus("unauth");
      }
    }
    check();
    return () => { mounted = false; };
  }, []);

  if (status === "loading") return null; // or a spinner component

  return status === "ok" ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
